/**
 * 业务配置
 * 职责：业务逻辑相关配置
 */

export const BUSINESS_CONFIG = {
  // 缓存配置（分钟）
  CACHE: {
    USER_INFO_EXPIRE: 30,
    LABEL_LIST_EXPIRE: 5,
    TEMPLATE_LIST_EXPIRE: 10,
    ENTERPRISE_INFO_EXPIRE: 60,
  },

  // 标签配置
  LABEL: {
    MAX_NAME_LENGTH: 100,
    MAX_DESCRIPTION_LENGTH: 500,
    AUTO_SAVE_INTERVAL: 30000, // 30秒
    VERSION_LIMIT: 50,
  },

  // 模板配置
  TEMPLATE: {
    MAX_NAME_LENGTH: 50,
    MAX_DESCRIPTION_LENGTH: 200,
    PREVIEW_THUMBNAIL_SIZE: 200,
  },

  // 企业配置
  ENTERPRISE: {
    MAX_NAME_LENGTH: 100,
    MAX_DESCRIPTION_LENGTH: 1000,
    MAX_USERS: 100,
  },

  // 合规检测配置
  COMPLIANCE: {
    AUTO_CHECK: true,
    CHECK_INTERVAL: 60000, // 1分钟
  },

  // 二维码配置
  QRCODE: {
    // 配置优先级（按顺序）：
    // 1. 环境变量 REACT_APP_QRCODE_BASE_URL（最优先，用于开发/生产环境统一配置）
    // 2. 后端接口返回值（后端可动态返回）
    // 3. 环境变量 REACT_APP_PUBLIC_URL（备选）
    // 4. 当前窗口源（最后回退）
    BASE_URL: process.env.REACT_APP_QRCODE_BASE_URL
             || process.env.REACT_APP_PUBLIC_URL
             || 'https://label.huapubio.com.cn', // 生产环境默认值

    // 二维码尺寸配置
    DISPLAY_SIZE: 200, // 显示尺寸（像素）
    DOWNLOAD_SIZE: 400, // 下载尺寸（像素）

    // 二维码容错率：L(7%), M(15%), Q(25%), H(30%)
    ERROR_CORRECTION_LEVEL: 'H', // 使用最高容错率，提高识别率
  },
};

export default BUSINESS_CONFIG;


